/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation VendorAccounttDirectoryUpsertMutation($vendorAccounttDirectoryId: ID, $displayName: String) {
  VendorAccounttDirectoryUpsert(vendorAccounttDirectoryId: $vendorAccounttDirectoryId, displayName: $displayName) {
    id
    message
    status
  }
}
`
